module.exports = __webpack_public_path__ + "img/icon-20-close-light.a1675488.svg";